module.exports = __webpack_public_path__ + "static/media/glass-cheers.acb56399.svg";